import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import {
  Environment,
  MacchineComponenti,
  IsErrorValues,
  IMacchineComponenti_TableModel,
  ModelNumStr,
  ModelNumStrNav,
  NgPrintQrModel,
} from '../../models/-index';
import { Observable } from 'rxjs';

@Injectable()
export class MacchineComponentiService extends CrudGenericsService<MacchineComponenti, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/MacchineComponenti`);
    this.base = `${env.apiUrl}/api/MacchineComponenti/`;
  }

  public SuggestNext_CodProgressivoComponente(item: MacchineComponenti): Observable<IsErrorValues> {
    const url = this.base + 'SuggestNext_CodProgressivoComponente';
    return this.http.post<IsErrorValues>(`${url}`, item);
  }
  public Get4Select_ByMacchina(id: number): Observable<ModelNumStr[]> {
    const url = this.base + 'Get4Select_ByMacchina?id=' + id;
    return this.http.get<ModelNumStr[]>(`${url}`);
  }
  public Get4Select_MacchinaNavigation(): Observable<ModelNumStrNav[]> {
    const url = this.base + 'Get4Select_MacchinaNavigation';
    return this.http.get<ModelNumStrNav[]>(`${url}`);
  }
  public GetMacchineComponenti_TableModel(): Observable<IMacchineComponenti_TableModel[]> {
    const url = this.base + 'GetMacchineComponenti_TableModel';
    return this.http.get<IMacchineComponenti_TableModel[]>(`${url}`);
  }

  // print etichetta
  GetNgPrintQrModel(id): Observable<NgPrintQrModel> {
    const u = `${this.base}GetNgPrintQrModel?id=${id}`;
    return this.http.get<NgPrintQrModel>(u);
  }
}
